/* eslint-disable jsx-a11y/anchor-has-content */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';
import classNames from 'classnames';
import Arrow from 'react-icons/lib/fa/sort-desc';

import Button from './Button';
import { banners, figures } from '../utils/image-handler';
import initFacebookShare from '../utils/facebook-handler';

import circleImg from '../images/final-2.svg';
import logo from '../images/final-logo.png';

class Final extends Component {
  static shareOnFacebook(href) {
    window.FB.ui({
      method: 'share',
      href,
      mobile_iframe: true
    });
  }

  constructor() {
    super();

    this.activateButton = this.activateButton.bind(this);
    this.deactivateButton = this.deactivateButton.bind(this);

    this.state = {
      isButton0Active: false,
      isButton1Active: false,
      isButton2Active: false,
      isButton3Active: false
    };
  }

  componentDidMount() {
    initFacebookShare();
  }

  activateButton(e) {
    const id = e.target.dataset.btnid;
    this.setState({
      [`isButton${id}Active`]: true
    });
  }

  deactivateButton() {
    this.setState({
      isButton0Active: false,
      isButton1Active: false,
      isButton2Active: false,
      isButton3Active: false
    });
  }

  render() {
    const { result } = this.props;

    const Element = Scroll.Element;
    const scroller = Scroll.scroller;

    return (
      <div className="container full-width" id="container">
        <div className="container horizontal-center full-height full-width">
          <div className="row">
            <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
              <img
                src={banners[result.bannerImage]}
                className="img-responsive img-title img-lg-title"
                alt={result.title}
              />
            </div>
          </div>
          {/* result */}
          <div className="row margin-top-xl">
            <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
              <div style={{ padding: '0 7.5%' }}>
                <img
                  src={figures[result.figureImage]}
                  className="img-responsive img-lg-title"
                  alt={result.caption}
                />
              </div>
            </div>
          </div>
          <div className="row margin-top-lg text-center">
            <Arrow
              className="btn-arrow down-there"
              onClick={() => {
                scroller.scrollTo('anchor', {
                  duration: 500,
                  delay: 100,
                  smooth: true,
                  containerID: 'container'
                });
              }}
            />
          </div>
        </div>
        <Element name="anchor" />
        {/* quote */}
        <div className="container full-width full-height background-white">
          {/* decoration */}
          <div className="deco" />
          {/* content */}
          <div className="mobile-center-adj vertical-horizontal-center full-width">
            <div className="row">
              <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-lg-4 col-lg-offset-4 text-center">
                <div className="dialog dialog-red horizontal-center">
                  <h2 className="margin-no">
                    {result.quote}
                  </h2>
                  <p className="margin-no margin-top-md">
                    - {result.quote_from} -
                  </p>
                </div>
              </div>
            </div>
            <div className="row margin-xs-top-lg margin-sm-top-lg">
              <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">
                <div className="dialog horizontal-center">
                  <h4 className="margin-no padding-sm">
                    {result.wisdom}
                  </h4>
                </div>
              </div>
            </div>
            <div className="row margin-xs-top-lg margin-sm-top-lg">
              <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
                <img
                  src={circleImg}
                  className="img-responsive img-sm"
                  alt="Figure"
                />
              </div>
            </div>
            <div className="row margin-xs-top-lg margin-sm-top-lg">
              <div className="col-xs-5 col-xs-offset-1 col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4 text-right">
                <Button
                  data-btnid="2"
                  data-type="quote"
                  className={classNames(
                    'btn',
                    'btn-default',
                    'btn-lg',
                    'margin-right'
                  )}
                  onClick={(e) => {
                    Final.shareOnFacebook(
                      result[`fb_share_href_${e.target.dataset.type}`]
                    );
                  }}
                >
                  分享箴言
                </Button>
              </div>
              <div className="col-xs-5 col-sm-3 col-md-2 text-left">
                <Button
                  data-btnid="1"
                  data-type="princess"
                  className={classNames(
                    'btn',
                    'btn-default',
                    'btn-lg',
                    'margin-left'
                  )}
                  onClick={(e) => {
                    Final.shareOnFacebook(
                      result[`fb_share_href_${e.target.dataset.type}`]
                    );
                  }}
                >
                  分享死法
                </Button>
              </div>
            </div>
            <div className="row margin-xs-top-lg margin-sm-top-lg">
              <div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 text-center">
                <a className="logo" href="http://feel-more.org/">
                  <img src={logo} alt="Fell More Logo" />
                </a>
              </div>
            </div>
          </div>
          <div className="footer full-width background-yellow" />
        </div>
      </div>
    );
  }
}

Final.propTypes = {
  result: PropTypes.shape().isRequired
};

export default Final;



// WEBPACK FOOTER //
// ./app/components/Final.js